import angular from 'angular'
import preWarnCtrl from './preWarnCtrl'
import choosePersonCtrl from './choosePersonCtrl'

import { preWarn } from 'redevConfig'

const setting = (preWarn && preWarn.setting) || ''
const list = (preWarn && preWarn.list) || ''

const preWarnListCtrl = list ? require(`redevelopment/system/preWarn/${list.controllerName}`) : require('./preWarnListCtrl')
const preWarnSettingCtrl = setting ? require(`redevelopment/system/preWarn/${setting.controllerName}`) : require('./preWarnSettingCtrl')

const preWarnListPage = list ? require(`redevelopment/system/preWarn/${list.templateName}`) : require('./views/prewarnlist.html')
const settingPage = setting ? require(`redevelopment/system/preWarn/${setting.templateName}`) : require('./views/prewarnsetting.html')

const importModalPreCtrl = require('./importModalPreCtrl')
export default angular
    .module('system.settingcenter.preWarn', [])
    .config([
        '$stateProvider',
        function config($stateProvider) {
            $stateProvider
                .state('system.settingcenter.preWarn', {
                    abstract: true,
                    url: '/preWarn',
                    template: '<div ui-view></div>',
                    // controller: 'preWarnCtrl',
                    title: '预警设置',
                    default: 'system.settingcenter.preWarn.list',
                })
                .state('system.settingcenter.preWarn.list', {
                    url: '/list',
                    template: preWarnListPage,
                    controller: 'preWarnListCtrl',
                })
                .state('system.settingcenter.preWarn.setting', {
                    url: '/setting/:id',
                    template: settingPage,
                    controller: 'preWarnSettingCtrl',
                    title: '设置预警规则',
                })
        },
    ])
    .controller('preWarnCtrl', preWarnCtrl)
    .controller('preWarnListCtrl', preWarnListCtrl.default)
    .controller('preWarnSettingCtrl', preWarnSettingCtrl.default)
    .controller('importModalPreCtrl', importModalPreCtrl.default)
    .controller('choosePersonCtrl', choosePersonCtrl).name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/preWarn/index.js